import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { ScrollArea } from '../components/ui/scroll-area';
import { Loader2, BookOpen, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BookPreviewModal = ({ bookId, isOpen, onClose }) => {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen && bookId) {
      const fetchPreview = async () => {
        setLoading(true);
        try {
          const response = await axios.get(`${API}/books/${bookId}/preview`);
          setPreview(response.data);
        } catch (error) {
          console.error('Error fetching preview:', error);
        }
        setLoading(false);
      };
      fetchPreview();
    }
  }, [bookId, isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] p-0">
        <DialogHeader className="p-6 pb-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <BookOpen className="h-6 w-6 text-primary" />
              <div>
                <DialogTitle className="font-heading text-xl">
                  {preview?.title || 'Book Preview'}
                </DialogTitle>
                {preview?.author && (
                  <p className="text-sm text-muted-foreground">by {preview.author}</p>
                )}
              </div>
            </div>
          </div>
        </DialogHeader>

        <ScrollArea className="h-[60vh] px-6 pb-6">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          ) : preview?.preview_content ? (
            <div className="prose prose-stone max-w-none">
              <div className="whitespace-pre-wrap font-serif text-base leading-relaxed">
                {preview.preview_content}
              </div>
              <div className="mt-8 p-4 bg-muted rounded-sm text-center">
                <p className="text-sm text-muted-foreground mb-2">
                  This is a preview. Purchase the book to read more.
                </p>
              </div>
            </div>
          ) : (
            <div className="text-center py-12">
              <BookOpen className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No preview available for this book.</p>
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
